var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-flex gap-2 flex-wrap"},[(_vm.showBm)?_c('b-badge',{staticClass:"approval-step-badge"},[_vm._v("ผู้จัดการคลัง")]):_vm._e(),(_vm.showHq)?_c('b-badge',{staticClass:"approval-step-badge"},[_vm._v("สำนักงานใหญ่")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }